const WA_LINK = "https://wa.me/50766132697?text=Hola%2C%20quiero%20agendar%20una%20cita%20con%20el%20Dr.%20Erick%20Tejada";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/52cacbd69c110f9bfefdd1dbf60c243c.jpg"
          alt="Clínica de Colposcopia Dr. Erick Tejada en Ciudad de Panamá"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-800/75 to-slate-700/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-5 md:px-8 pt-24 pb-20">
        <div className="max-w-xl lg:max-w-2xl">
          {/* Badge */}
          <div
            className="inline-flex items-center gap-2 bg-teal-500/20 border border-teal-400/40 text-teal-300 text-xs font-medium px-3 py-2 rounded-full mb-5 flex-wrap"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            <i className="ri-shield-check-line flex-shrink-0"></i>
            <span>Especialista en Colposcopia · Ciudad de Panamá</span>
          </div>

          {/* Headline */}
          <h1
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Prevención y Detección{" "}
            <span className="italic font-normal" style={{ fontFamily: "'Lora', serif" }}>
              Temprana del VPH
            </span>{" "}
            en Panamá
          </h1>

          <p
            className="text-white/80 text-base md:text-lg leading-relaxed mb-8 max-w-lg"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            El Dr. Erick Tejada es especialista en ginecología y colposcopia, enfocado en la detección temprana y tratamiento de lesiones asociadas al VPH en Ciudad de Panamá.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3 mb-8">
            <a
              href={WA_LINK}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center justify-center gap-3 bg-green-500 hover:bg-green-600 text-white font-semibold px-7 py-4 rounded-full transition-all text-sm md:text-base whitespace-nowrap cursor-pointer w-full sm:w-auto"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              <i className="ri-whatsapp-line text-lg md:text-xl flex-shrink-0"></i>
              Agendar Cita por WhatsApp
            </a>
            <a
              href="tel:+50766132697"
              className="flex items-center justify-center gap-3 bg-white/15 hover:bg-white/25 border border-white/40 text-white font-semibold px-7 py-4 rounded-full transition-all text-sm md:text-base whitespace-nowrap cursor-pointer w-full sm:w-auto"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              <i className="ri-phone-line text-lg md:text-xl flex-shrink-0"></i>
              +507 6613-2697
            </a>
          </div>

          {/* Trust Note */}
          <p
            className="text-white/60 text-xs md:text-sm flex flex-wrap items-center gap-x-2 gap-y-1"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line text-teal-300"></i>
              Lun–Vie 9AM–5PM
            </span>
            <span className="text-white/30 hidden sm:inline">·</span>
            <span className="flex items-center gap-1.5">
              <i className="ri-calendar-check-line text-teal-300"></i>
              Cita previa
            </span>
            <span className="text-white/30 hidden sm:inline">·</span>
            <span className="flex items-center gap-1.5">
              <i className="ri-chat-check-line text-teal-300"></i>
              Respuesta rápida
            </span>
          </p>
        </div>
      </div>

      {/* Floating stats — only desktop */}
      <div className="absolute bottom-8 right-6 md:right-10 z-10 hidden lg:flex flex-col gap-3">
        {[
          { icon: "ri-microscope-line", text: "Detección Temprana", sub: "Tecnología avanzada" },
          { icon: "ri-heart-pulse-line", text: "Atención Personalizada", sub: "Enfoque preventivo" },
          { icon: "ri-award-line", text: "Especialista Certificado", sub: "Colposcopia y VPH" },
        ].map((stat) => (
          <div
            key={stat.text}
            className="flex items-center gap-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-xl px-4 py-3"
          >
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-teal-500/30 flex-shrink-0">
              <i className={`${stat.icon} text-teal-300 text-lg`}></i>
            </div>
            <div>
              <p className="text-white text-xs font-semibold" style={{ fontFamily: "'Poppins', sans-serif" }}>
                {stat.text}
              </p>
              <p className="text-white/60 text-xs" style={{ fontFamily: "'Poppins', sans-serif" }}>
                {stat.sub}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
